<template>
<a-breadcrumb :routes="routes" separator=">">
  <template slot="itemRender" slot-scope="{route, params, routes, paths}" >
   <span v-if="routes.indexOf(route) === routes.length - 1">
      {{route.meta.name}}
    </span>
    <router-link v-else :to="route.path">
      {{route.meta.name}}
    </router-link>
  </template>
</a-breadcrumb>
</template>
<script>
  export default {
    name: 'hp-manager-breadcrumb',
    data() {
      return {
        routes: [],
        pp:""
      }
    },
   watch: {
      $route: 'breadcrumbRefresh',
    },
    mounted() {
      this.breadcrumbRefresh();
    },
    methods: {
      breadcrumbRefresh() {
        let routes = [], allRouter = [], findParent = (all,routeName) => {
          all.map(item => {
            if(item.name === routeName){
              routes.push(Object.assign({}, item));
              if(item.meta && item.meta.parent){
                findParent(all, item.meta.parent)
              }
            }
          })
        },arayToSingle = (all) => {
          all.map(item => {
            allRouter.push(item)
            if(item.children){
              arayToSingle(item.children)
            }
          })
        };
        arayToSingle(this.$router.options.routes);
        findParent(allRouter,this.$route.name)
        this.routes = routes.reverse();
      },
    },
  }
</script>

<style lang="scss">
  @import "../../assets/scss/output.scss";
.ant-breadcrumb{line-height: 40px}
.hp-manager-header-breadcrumb{height: 40px;}
  @include b(breadcrumb) {
    border-bottom: 2px solid $--body-background-color;
    @include e(list) {
      display: inline-block;
      vertical-align: top;
      margin-left: 10px;
    }
    @include e(link) {
      display: inline-block;
      vertical-align: top;
      min-width: 50px;
      padding: 0 10px;
      margin-right: 10px;
      text-align: center;
      border-bottom: 2px solid $--white;
      @include transition();
      @include pseudo(hover) {
        color: $--white;
      }
      @include when(active) {
        color: $--white;
        border-bottom: 2px solid $--white;
      }
    }
    @include e(user) {
      position: absolute;
      right: 0;
      top: 0;
      bottom: 0;
      padding: 0 10px;
    }
    .el-breadcrumb{
      line-height: 60px;
    }
    .el-breadcrumb__inner,
    .el-breadcrumb__inner a {
      font-weight: normal;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/navigation/breadcrumb.vue